export default __webpack_public_path__ + "static/media/waterstream.ee4a9827.ogg";